module.exports = __webpack_public_path__ + "img/mobile scanner stand09.a2cabb39.jpg";